import React from 'react';
import { Outlet } from 'react-router-dom';

const OrgBaseLayout = () => {
    return <Outlet />;
};

export default OrgBaseLayout;
